import { reducerWithInitialState } from 'typescript-fsa-reducers';
import * as lodash from 'lodash';
import { MapActions } from './map.action';
import {
  Position, Address, GPSStatus, MapAreaPosition, RouteInfo,
} from '../../type/map/map.type';

export type MapState = {
  flickLoad: boolean;
  map: globalThis.google.maps.Map | null;
  gpsStatus: GPSStatus;
  routeInfo: RouteInfo | null;
  areaBtnDisabled: boolean;
  routeAreaBtnDisabled: boolean;
  // destinationPos: Position | null;
  humanPos: Position | null;
  centerPos: Position | null;
  searchPos: Position | null;
  searchAddress: Address | null;
  mapAreaPos: MapAreaPosition | null;
  routeMapAreaPos: MapAreaPosition | null;
  gpsId: number | null;
  loading: boolean;
  zoomLevel: number,
  routeZoomLevel: number,
  routeSearchName: string,
};

const initialState: MapState = {
  areaBtnDisabled: false,
  routeAreaBtnDisabled: false,
  flickLoad: true,
  map: null,
  routeInfo: null,
  mapAreaPos: null,
  gpsStatus: 'watch',
  routeMapAreaPos: null,
  humanPos: null,
  centerPos: null,
  searchPos: null,
  searchAddress: null,
  gpsId: null,
  loading: false,
  zoomLevel: 17,
  routeZoomLevel: 17,
  routeSearchName: '',
};

export const MapReducer = reducerWithInitialState<MapState>(initialState)
  .case(MapActions.loading, (state, payload) => ({
    ...state,
    loading: payload,
  }))
  .case(MapActions.setRouteInfo, (state, payload) => ({
    ...state,
    routeInfo: lodash.cloneDeep(payload),
  }))
  .case(MapActions.gps.setId, (state, payload) => ({
    ...state,
    gpsId: payload,
  }))
  .case(MapActions.setGpsStatus, (state, payload) => ({
    ...state,
    gpsStatus: lodash.cloneDeep(payload),
  }))
  .case(MapActions.setCenterPos, (state, payload) => ({
    ...state,
    centerPos: lodash.cloneDeep(payload),
  }))
  .case(MapActions.setAreaBtnDisabled, (state, payload) => ({
    ...state,
    areaBtnDisabled: lodash.cloneDeep(payload),
  }))
  .case(MapActions.setRouteAreaBtnDisabled, (state, payload) => ({
    ...state,
    routeAreaBtnDisabled: lodash.cloneDeep(payload),
  }))
  .case(MapActions.setMapAreaPosition, (state, payload) => ({
    ...state,
    mapAreaPos: lodash.cloneDeep(payload),
  }))
  .case(MapActions.setRouteMapAreaPosition, (state, payload) => ({
    ...state,
    routeMapAreaPos: lodash.cloneDeep(payload),
  }))
  .case(MapActions.setHumanPos, (state, payload) => ({
    ...state,
    humanPos: lodash.cloneDeep(payload),
  }))
  .case(MapActions.setSearchPos, (state, payload) => ({
    ...state,
    searchPos: lodash.cloneDeep(payload),
  }))
  .case(MapActions.setSearchAddress, (state, payload) => ({
    ...state,
    searchAddress: lodash.cloneDeep(payload),
  }))
  .case(MapActions.setMap, (state, payload) => ({
    ...state,
    map: payload,
  }))
  .case(MapActions.setFlickLoad, (state, payload) => ({
    ...state,
    flickLoad: lodash.cloneDeep(payload),
  }))
  .case(MapActions.setZoomLevel, (state, payload) => ({
    ...state,
    zoomLevel: payload !== null ? payload : 15,
  }))
  .case(MapActions.setRouteZoomLevel, (state, payload) => ({
    ...state,
    routeZoomLevel: payload !== null ? payload : 15,
  }))
  .case(MapActions.setRouteSearchName, (state, payload) => ({
    ...state,
    routeSearchName: lodash.cloneDeep(payload),
  }))
  .case(MapActions.resetState, () => initialState)
  .default((state) => state);
